export default {
  liveClassSchedule: {
    id: "",
    courseOutlineId: "",
    vdoSetId: "",
    vdoSetUnitId: "",
    no: 0,
    nameLocal: "",
    nameEng: "",
    vdoLength: 0,
    vdoStreamPath: "",
    teacherId: "",
    isEnabled: true,
    externalLink: "",
    externalPassword: "",
    remark: "",
  },
  liveClassSchedules: [],
  processing: false,
  error: null,
  success: null,
}



